
import React from "react";
import { Link } from "react-router-dom";
import { MagicLetterBoxLink } from "@/components/funnel/MagicLetterBoxLink";

const Footer = () => {
  // Function to scroll to top when clicking internal links
  const scrollToTop = () => {
    window.scrollTo({
      top: 0,
      behavior: "smooth"
    });
  };

  return (
    <footer className="bg-elfGreen-ink py-12 text-white">
      <div className="container mx-auto px-4">
        <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
          <div>
            <h3 className="text-xl font-bold mb-4">Elf Letter Bot</h3>
            <p className="mb-4">
              Free Christmas resources and three personalized PDF letter deliveries per email address. Continue with a paid Family membership at The Magic Letter Box, from the same founder.
            </p>
            <p>© {new Date().getFullYear()} Elf Letter Bot. All rights reserved.</p>
          </div>
          
          <div>
            <h3 className="text-xl font-bold mb-4">Quick Links</h3>
            <ul className="space-y-2">
              <li>
                <Link to="/" className="hover:underline" onClick={scrollToTop}>Home</Link>
              </li>
              <li>
                <Link to="/blog/" className="hover:underline" onClick={scrollToTop}>Blog</Link>
              </li>
              <li><Link to="/elf-help/" className="hover:underline" onClick={scrollToTop}>Quick Elf Help</Link></li>
              <li>
                <Link to="/about/" className="hover:underline" onClick={scrollToTop}>About Us</Link>
              </li>
              <li>
                <MagicLetterBoxLink
                  source="footer"
                  className="hover:underline"
                >
                  The Magic Letter Box
                </MagicLetterBoxLink>
              </li>
            </ul>
          </div>
          
          <div>
            <h3 className="text-xl font-bold mb-4">Legal</h3>
            <ul className="space-y-2">
              <li>
                <Link to="/terms/" className="hover:underline" onClick={scrollToTop}>Terms of Service</Link>
              </li>
              <li>
                <Link to="/privacy/" className="hover:underline" onClick={scrollToTop}>Privacy Policy</Link>
              </li>
              <li>
                <Link 
                  to="/admin/login"
                  className="text-white hover:underline text-left opacity-80"
                  onClick={scrollToTop}
                >
                  Admin
                </Link>
              </li>
            </ul>
          </div>
        </div>
        
        <div className="mt-8 pt-8 border-t border-elfGreen-dark flex flex-col md:flex-row justify-between items-center">
          <p>
            Have questions? Contact us at <a href="mailto:support@elfletterbot.com" className="underline hover:text-elfPink-light">support@elfletterbot.com</a>
          </p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
